export const ElenEvents = {};

ElenEvents.hasActiveEvent = () => {
  return ElenEvents.packageEvent() ||
    ElenEvents.meetingLisa() ||
    ElenEvents.beachTrip() ||
    LisaEvents.conclusion() ||
    (AnastasiaEvents.disappear() && AnastasiaEvents.disappearExplained)
    ;
}

ElenEvents.hasActiveEventHomeEvent = () => {
  return ElenEvents.pubAftermath();
}

ElenEvents.displayHint = () => {
  return ElenEvents.packageEvent() ||
    ElenEvents.meetingLisa() ||
    (AnastasiaEvents.disappear() && AnastasiaEvents.disappearExplained)
    ;
}

ElenEvents.packageEvent = () => {
  return Yosemite.EventStateManager.firstDayWork === true && YsServices.questService.status(6) === -1;
}

ElenEvents.meetingLisa = () => {
   // czy już drugi rozdział
   if(!EventStateService.secondChapterIntro) {
    return false;
  }

  //zakończony quest z paczką
  if(!EventStateService.lisaFirstEvent) {
    return false;
  }

  return !EventStateService.elenMeetingLisa;
}

ElenEvents.pubAftermath = () => {
  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  //czy była kłótnia w barze
  if (!EventStateService.lisaArgumentInBar) {
    return false;
  }

  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.EVENING) {
    return false;
  }

  return !EventStateService.elenPubAftermath;
}

ElenEvents.beachTrip = () => {
  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  if(!EventStateService.lisaPubAftermath) {
    return false;
  }

  return !EventStateService.elenBeachTrip;
}